import TableHeaderCell from "./table-header-cell";

export default function TableHeader({ headerGroups }) {
  return (
    <thead className="bg-cp-grey-200">
      {headerGroups.map(({ id, headers }) => (
        <tr key={id}>
          {headers.map((header) => (
            <TableHeaderCell key={header.id} header={header} />
          ))}
        </tr>
      ))}
    </thead>
  );
}
